export default __webpack_public_path__ + "static/media/imgHormonas.3ca0ac36.png";